'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.configureLoggers = exports.loggers = undefined;

var _logTypesConstants = require('./log-types-constants');

var _logLevelConstants = require('./log-level-constants');

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

var loggers = exports.loggers = [];

var getLoggerByConfig = function getLoggerByConfig(config) {
  var minLogLevel = config.minimumLogLevel || _logLevelConstants.INFO;

  if (config.type.toUpperCase() === _logTypesConstants.APP_INSIGHTS) {
    if (!config.instrumentationKey) {
      throw new Error('Application insights configuration ' + JSON.stringify(config) + ' doesn\'t contain a instrumentation key');
    }
    var ApplicationInsightsLogger = require('./loggers/application_insight_logger'); //eslint-disable-line
    return new ApplicationInsightsLogger({
      instrumentationKey: config.instrumentationKey,
      minimumLogLevel: minLogLevel
    });
  }

  if (config.type.toUpperCase() === _logTypesConstants.CONSOLE) {
    var ConsoleLogger = require('./loggers/console_logger'); //eslint-disable-line
    return new ConsoleLogger({ minimumLogLevel: minLogLevel });
  }

  if (config.type.toUpperCase() === _logTypesConstants.CORDOVA_FILE) {
    var CordovaFileLogger = require('./loggers/cordova_file_logger'); //eslint-disable-line
    return new CordovaFileLogger({
      logfileRotationCount: config.rotationCount || 10,
      minimumLogLevel: minLogLevel
    });
  }

  throw new Error('Unexpected logger configuration ' + JSON.stringify(config));
};

var configureLoggers = exports.configureLoggers = function configureLoggers() {
  var loggerConfigs = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [{
    minimumLogLevel: _logLevelConstants.INFO,
    type: _logTypesConstants.CONSOLE
  }, {
    type: _logTypesConstants.APP_INSIGHTS,
    instrumentationKey: 'a00d3812-d821-47f2-9d84-9de5afc9af2f',
    minimumLogLevel: _logLevelConstants.INFO
  }];

  try {
    return loggers.push.apply(loggers, _toConsumableArray(loggerConfigs.map(function (config) {
      if (!config.type) {
        throw new Error('Logger configuration ' + JSON.stringify(config) + ' doesn\'t contain a type');
      }
      return getLoggerByConfig(config);
    })));
  } catch (err) {
    // eslint-disable-next-line no-console
    console.error(err);
    return [];
  }
};